"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Badge } from "@/components/ui/badge";
const stats = [{
  value: "20+",
  label: "Countries"
}, {
  value: "50+",
  label: "Mega-Projects"
}, {
  value: "360°",
  label: "Lifecycle Mgmt"
}];
export default function TheAotoStandard() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="the-aoto-standard" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {}
          <div ref={imageRef} className={`relative w-full aspect-[4/5] lg:aspect-square rounded-[2rem] overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <img src="https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/12.png" alt="AOTO Cultural Site Architectural Rendering" className="w-full h-full object-cover" />
            {}
            <div className="absolute inset-0 border border-white/10 rounded-[2rem] pointer-events-none"></div>
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="flex items-center gap-4 mb-8">
              <Badge variant="secondary" className="px-3 py-1 text-sm font-mono tracking-widest rounded-md">
                01
              </Badge>
              <span className="text-sm font-semibold tracking-widest text-muted-foreground uppercase">COMPANY INTRODUCTION</span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-foreground leading-[1.1] mb-8">AOTO NEXUS</h2>

            <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl mb-12">
              <p>AOTO NEXUS provides integrated EPCO solutions for cultural tourism development, guiding projects from vision to destination. Our services cover planning and design, engineering, procurement, investment, and destination operations, ensuring seamless coordination across every stage. Each service can also be delivered independently to meet specific project needs.</p>
              <p>Supported by an experienced team of planners, engineers, and operators, we combine global perspective with professional expertise to deliver high-quality tourism destinations and reliable solutions for governments, developers, and investors worldwide.</p>
            </div>

            {}
            <div className="grid grid-cols-3 gap-6 pt-10 border-t border-border/60">
              {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col gap-2">
                  <span className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tighter">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm font-medium text-muted-foreground uppercase tracking-wider">
                    {stat.label}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}